import { render, staticRenderFns } from "./VaIconMenuCollapsed.vue?vue&type=template&id=925a0f9c"
import script from "./VaIconMenuCollapsed.vue?vue&type=script&lang=js"
export * from "./VaIconMenuCollapsed.vue?vue&type=script&lang=js"
import style0 from "./VaIconMenuCollapsed.vue?vue&type=style&index=0&id=925a0f9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports